export default __webpack_public_path__ + "static/media/training.61dc2432.svg";